export const formatSvgUrl = ({ secure_url: url, format }) => {
	if (!url) return url;
	const isSVG = format === "svg";
	const result = isSVG
		? url.replace("/image/upload/", "/image/upload/f_svg/").replace("f_auto", "f_svg")
		: url;
	return result;
};
